import Button from '@admin/components/button'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Color extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { 
          label: 't(Previous)',
          color: 'blue',
          basic: true,
          handler: this._handleBack 
        },
        { 
          label: 't(Next)',
          color: 'blue',
          handler: this._handleSubmit 
        }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Logo Color Selection)',
              instructions: (
                <>
                  Please specify the colors you\'d like to use for your logo designs. You may choose multiple color options. 
                  View our <Button { ...this._getColors() } /> to help you choose a specific color or specify a generic color description
                </>
              ),
              type: 'segment',
              fields: [
                { 
                  label: 't(What colors represent your brand?)',
                  name: 'logo_colors',
                  type: 'textarea',
                  required: true,
                  defaultValue: config.logo_colors 
                },
                { 
                  label: 't(What colors would you not like to see?)',
                  name: 'logo_colors_dislike',
                  type: 'textarea',
                  required: true,
                  defaultValue: config.logo_colors_dislike 
                }
              ] 
            }
          ]
        }
      ]
    }
  }

  _getColors() {
    return {
      label: 'Color Choice Helper',
      className: 'link',
      link: '/imagecache/images/color-choice-helper.jpg'
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    const { formdata } = this.props
    this.props.onNext({
      ...formdata,
      ...config
    })
  }

}

export default Color
